import React, { useState } from 'react';

import InformationModal from 'components/Modals/informationModal';

// TODO remove this once all freecode pages are done and/or not using this any more

export default function PageUnderConstruction() {
  const [displayModal, setDisplayModal] = useState(true);

  return (
    displayModal && (
      <InformationModal
        title="Under Construction"
        text="This page is currently under construction"
        closeModal={() => setDisplayModal(false)}
      />
    )
  );
}
